import { useCallback, useEffect, useRef, useState } from "react";

export function useUndo(items, tb, apply) {
  const h = useRef({ past: [], future: [], last: 0 });
  const cur = useRef({ items, tb });
  cur.current = { items, tb };
  const [, force] = useState(0);
  const bump = () => force((x) => x + 1);

  const record = useCallback(() => {
    const now = Date.now();
    if (now - h.current.last > 700) {
      h.current.past.push(cur.current);
      if (h.current.past.length > 100) h.current.past.shift();
    }
    h.current.last = now;
    h.current.future = [];
    bump();
  }, []);
  const undo = useCallback(() => {
    if (!h.current.past.length) return;
    h.current.future.push(cur.current);
    apply(h.current.past.pop());
    h.current.last = 0;
    bump();
  }, [apply]);
  const redo = useCallback(() => {
    if (!h.current.future.length) return;
    h.current.past.push(cur.current);
    apply(h.current.future.pop());
    h.current.last = 0;
    bump();
  }, [apply]);
  const reset = useCallback(() => { h.current = { past: [], future: [], last: 0 }; bump(); }, []);

  useEffect(() => {
    const onKey = (e) => {
      if (!(e.ctrlKey || e.metaKey)) return;
      const k = e.key.toLowerCase();
      if (k === "z" && !e.shiftKey) { e.preventDefault(); undo(); }
      else if ((k === "z" && e.shiftKey) || k === "y") { e.preventDefault(); redo(); }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [undo, redo]);

  return { record, undo, redo, reset, canUndo: h.current.past.length > 0, canRedo: h.current.future.length > 0, steps: h.current.past.length };
}
